import styled from '@emotion/styled'
import { Spinner } from 'react-bootstrap'

const Loader = () => {
    return <CustomLoader animation="border" data-testid="loader" />
}

const CustomLoader = styled(Spinner)`
    position: relative;
    color: var(--primary-color);
    width: 100px;
    height: 100px;
    border-width: 10px;
    margin: auto;
`

export default Loader
